// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
/**
 * Shapes used by the external voter registry reconciliation wizard.
 * Wire values match the backend's Rust enums exactly, so these describe
 * GraphQL response shapes directly with no translation layer.
 */
// Source-of-truth categories from the "Handling Inconsistencies" section,
// plus REENABLED (a voter Sequent disabled solely because of a prior
// Datafix delete call is re-enabled when the file no longer reports them
// Deleted).
export var ESyncChangeCategory;
(function (ESyncChangeCategory) {
    ESyncChangeCategory["VOTED_INTERNET"] = "VOTED_INTERNET";
    ESyncChangeCategory["VOTED_OTHER_CHANNEL"] = "VOTED_OTHER_CHANNEL";
    ESyncChangeCategory["DISABLED_DELETE_CALL"] = "DISABLED_DELETE_CALL";
    ESyncChangeCategory["DELETION_REVERTED"] = "DELETION_REVERTED";
    ESyncChangeCategory["PROFILE_UPDATE"] = "PROFILE_UPDATE";
    ESyncChangeCategory["VOTER_ADDED"] = "VOTER_ADDED";
    ESyncChangeCategory["REENABLED"] = "REENABLED";
    ESyncChangeCategory["VOTED_UNMARKED"] = "VOTED_UNMARKED";
    ESyncChangeCategory["ROW_FAILURE"] = "ROW_FAILURE";
})(ESyncChangeCategory || (ESyncChangeCategory = {}));
// Fixed column order for the "Patch Files Format" - every patch row carries
// all of these as <Field>_old/<Field>_new pairs, VoterID is the row key and
// is never one of them (VoterID cannot change).
export var PATCH_FIELDS = [
    "CountyMun",
    "DoB",
    "Ward",
    "Poll",
    "SchoolSupportCode",
    "Channel",
    "Deleted",
];
